import { ChangeEvent, useState } from 'react';
import { MappedPassengerType } from '../../types';
import isDateInFuture from '../../../../../utils/isDateInFuture';
import { toast } from 'react-toastify';

export default function useModals() {
  const [isReactivateDateSet, setIsReactivateDateSet] = useState(false);
  const [reactivateDate, setReactivateDate] = useState('');

  const [passengerBeingReactivated, setPassengerBeingReactivated] = useState('');
  const [pasengerBeingInactivated, setPassengerBeingInactivated] = useState('');
  const [passengerRoutingBeingShow, setPassengerRoutingBeingShow] = useState<MappedPassengerType>({} as MappedPassengerType);
  const [passengerInfoBeingShow, setPassengerInfoBeingShow] = useState<MappedPassengerType>({} as MappedPassengerType);

  const [reactivateModalShow, setReactivateModalShow] = useState(false);
  const [inactivateModalShow, setInactivateModalShow] = useState(false);
  const [passengerRoutingModalShow, setPassengerRoutingModalShow] = useState(false);
  const [infoModalShow, setInfoModalShow] = useState(false);

  const [reactivatePassengerCode, setReactivatePassengerCode] = useState<number | string>('');
  const [inactivatePassengerCode, setInactivatePassengerCode] = useState<number | string>('');

  function handleOpenReactivateModal(passengerName: string, employeeCode: number) {
    setPassengerBeingReactivated(passengerName);
    setReactivatePassengerCode(employeeCode);
    setReactivateModalShow(true);
  }

  function handleOpenInactivateModal(passengerName: string, employeeCode: number) {
    setPassengerBeingInactivated(passengerName);
    setInactivatePassengerCode(employeeCode);
    setInactivateModalShow(true);
  }

  function handleOpenPassengerRoutingModal(passengerInfo: MappedPassengerType) {
    setPassengerRoutingBeingShow(passengerInfo);
    setPassengerRoutingModalShow(true);
  }

  function handleOpenPassengerInfoModal(passengerInfo: MappedPassengerType) {
    setPassengerInfoBeingShow(passengerInfo);
    setInfoModalShow(true);
  }

  function handleReactivateDateChange(event: ChangeEvent<HTMLInputElement>) {
    const isFutureDate = isDateInFuture(event.target.value);
    if (!isFutureDate) {
      toast.warn('Não é possível reagendar a reativação para uma data passada!');
    }
    setReactivateDate(event.target.value);
  }

  return {
    passengerBeingReactivated,
    pasengerBeingInactivated,
    passengerRoutingBeingShow,
    reactivateModalShow,
    inactivateModalShow,
    passengerRoutingModalShow,
    handleOpenReactivateModal,
    handleOpenInactivateModal,
    handleOpenPassengerRoutingModal,
    isReactivateDateSet,
    reactivateDate,
    handleReactivateDateChange,
    setIsReactivateDateSet,
    passengerInfoBeingShow,
    infoModalShow,
    handleOpenPassengerInfoModal,
    setInactivateModalShow,
    setReactivateDate,
    setReactivateModalShow,
    setInfoModalShow,
    setPassengerRoutingModalShow,
    reactivatePassengerCode,
    inactivatePassengerCode,
  };
}
